var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiBuddy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7762 6.65015H6.7828C5.5466 6.65015 4.55322 7.64352 4.55322 8.87973V17.2462C4.55322 18.4824 5.5466 19.4758 6.7828 19.4758H9.45389C9.63049 19.4758 9.76294 19.6082 9.76294 19.7848V21.5067C9.76294 21.7495 10.0278 21.904 10.2265 21.7716L13.604 19.6524C13.7585 19.5641 13.9351 19.4978 14.1338 19.4978H17.8203C19.0565 19.4978 20.0499 18.5045 20.0499 17.2682V8.85765C20.0058 7.64352 19.0124 6.65015 17.7762 6.65015Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0054 10.7561H21.1974C21.6831 10.7561 22.0584 11.1314 22.0584 11.617V14.4868C22.0584 14.9724 21.6831 15.3477 21.1974 15.3477H20.0054V10.7561Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55298 10.7561H3.36093C2.87528 10.7561 2.5 11.1314 2.5 11.617V14.4868C2.5 14.9724 2.87528 15.3477 3.36093 15.3477H4.55298V10.7561Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76959 4.83996C9.41575 4.83996 9.93957 4.31614 9.93957 3.66998C9.93957 3.02382 9.41575 2.5 8.76959 2.5C8.12343 2.5 7.59961 3.02382 7.59961 3.66998C7.59961 4.31614 8.12343 4.83996 8.76959 4.83996Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8995 4.83996C16.5456 4.83996 17.0694 4.31614 17.0694 3.66998C17.0694 3.02382 16.5456 2.5 15.8995 2.5C15.2533 2.5 14.7295 3.02382 14.7295 3.66998C14.7295 4.31614 15.2533 4.83996 15.8995 4.83996Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0454 10.7562C14.0454 10.116 14.5752 9.58618 15.2154 9.58618C15.8556 9.58618 16.3854 10.116 16.3854 10.7562",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90186 10.7562C8.90186 10.116 9.43166 9.58618 10.0718 9.58618C10.712 9.58618 11.2418 10.116 11.2418 10.7562",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8994 5.2937V7.10386",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 4.83997V6.65012",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90186 15.149C8.90186 15.149 12.3014 16.9813 16.3632 15.149",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBuddy);
export default __webpack_public_path__ + "static/media/AiBuddy.0b176c20a7eb260fc1a19084d3607051.svg";
export { ForwardRef as ReactComponent };